// src/App.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';

import Home from './pages/Home';
import BookAppointment from './pages/BookAppointment';
import Reviews from './pages/Reviews';
import Header from './components/Header'; // Optional shared header
import Footer from './components/Footer';
import Blog from './pages/Blog';
import BlogDetails from './pages/BlogDetails';
import ScrollToTop from './components/ScrollToTop';
import Testimonials from './pages/Testimonials'; // Import the new page

function App() {
  return (
    <>
      <ScrollToTop />
      <div className="font-sans min-h-screen bg-white text-gray-900 flex flex-col">
        <Header />
        <div className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/book-appointment" element={<BookAppointment />} />
            <Route path="/reviews" element={<Reviews />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:id" element={<BlogDetails />} />
            <Route path="/testimonials" element={<Testimonials />} /> {/* Add the new route */}
          </Routes>
        </div>
        <Footer />
      </div>
    </>
  );
}

export default App;
